import {
  Add_CompanyProfile_Type,
  Get_All_CompanyProfile_Type,
  Get_Error,
  Get_Specific_CompanyProfile_Type,
  Update_Specififc_CompanyProfile_Type,
} from '../Types';

const intial = {
  CompanyProfile: [],
  CompanyProfileupdate: [],
  loading: true,
};

const Company_Profile_Reducer = (state = intial, action) => {
  switch (action.type) {
    case Add_CompanyProfile_Type:
      return {
        CompanyProfile: action.payload,
        loading: false,
      };
    case Get_All_CompanyProfile_Type:
      return {
        ...state,
        CompanyProfile: action.payload,
        loading: false,
      };
    case Update_Specififc_CompanyProfile_Type:
      return {
        ...state,
        CompanyProfileupdate: action.payload,
        loading: false,
      };
    case Get_Specific_CompanyProfile_Type:
      return {
        ...state,
        CompanyProfile: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        CompanyProfile: action.payload,
      };
    default:
      return state;
  }
};

export default Company_Profile_Reducer;
